module.exports = __webpack_public_path__ + "static/media/calculator.89597e88.svg";